const madmaxPath = 'framework/';
const gamePath = '';

const gameset = {
    "stageWidth": 1280,
    "stageHeight": 720,
    "loadGraphics": "c",
    "preferGraphics": "h",
    "amaTitle": "Super Joker 40",
    "gameName": "Super Joker 40",
    "mute": false,
    "gameType": "reel",
    "currency": "cents",
    "game_id": "super_joker_40",
    "casino_id": 0,
    "uxtype": "mobile",
    "gameSign": "Super Joker 40",
    "version": "h",
    "language": "en",
    "lineGameType": "normal", //"normal", "lines", "levels"

    "preloader": {},

    infoPages: {
        separated: true
    },

    scripts: [
        'framework/src/vendor/jquery.min.js',
        'framework/src/vendor/tween.js',
        'framework/src/vendor/ph.js'
    ],

    "system": {
        "audio" : {
            "tracks": [
                {
                    "name": "ui_Btn_Generic",
                    "url": madmaxPath + `assets/audio/ui_Btn_Generic.{ogg,mp3}`,
                    "classVol": "volume.buttonEffect"
                },
                {
                    "name": "ui_Btn_Up",
                    "classVol": "volume.buttonEffect",
                    "reference": "ui_Btn_Generic"
                },
                {
                    "name": "ui_Btn_Down",
                    "classVol": "volume.buttonEffect",
                    "reference": "ui_Btn_Generic"
                },
                {
                    "name": "button_click",
                    "reference": "ui_Btn_Generic"
                },
                {
                    name: 'Jackpot_sound',
                    classVol: 'volume.normalWin',
                    "url": `assets/JokerWinBanner/Jackpot_sound.{ogg,mp3}`,
                    loop: false,
                },
                {
                    name: 'JokerBonus_alert',
                    classVol: 'volume.normalWin',
                    "url": `assets/JokerWinBanner/JokerBonus_alert.{ogg,mp3}`,
                    loop: false,
                },
            ]
        }
    },
    "game": {
        "basic": {
            "symbolsCount": 10,
            "slotsCount": 20,
            "slotsRows": 4,
            "slotsColumns": 5,
            "pilarsCount": 5
        },
        "webfonts": [
                //your other webfonts, if any
                "UbuntuMono-Regular",
                "Audiowide-Regular",
            ],
        "layers": [
            "background",
            "wild",
            "reels",
            "joker",
            "reels_cover",
            "lines",
            "touchZone",
            "win",
            {
                "name": "bigWin",
                "layers": [
                    "coins",
                    "flares",
                    "frame",
                ]
            },
            "counter",
            "winFactors",
            {
                "name": "info",
                "layers": [
                    "background",
                    "pageOne",
                    "pageTwo",
                    "pageThree"
                ]
            },
            "logo",
            {
                "name": "freespins",
                "layers": [
                    "pageOne",
                    "pageTwo",
                    "pageThree",
                    "counter"
                ]
            },
			"preloader"
		],
        "subLayers": [],
        "totalBackgroundUrl": gamePath + `assets/img/$version/totalbackground.png`,
        "audio": {
            "tracks": [
                {
                    "name": "bonus_Joker_Expand",
                    "url": gamePath + `assets/audio/bonus_Joker_Expand.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "bonus_Joker_Idle_Loop_Normal",
                    "url": gamePath + `assets/audio/bonus_Joker_Idle_Loop_Normal.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "miscSounds.miscSounds1"
                },
                {
                    "name": "bonus_Joker_Idle_Loop_FS",
                    "url": gamePath + `assets/audio/bonus_Joker_Idle_Loop_FS.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "miscSounds.miscSounds1"
                },
                {
                    "name": "bonus_Door_Close",
                    "url": gamePath + `assets/audio/bonus_Door_Close.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "background.bonusGameBackground"
                },
                {
                    "name": "bonus_Door_Open",
                    "url": gamePath + `assets/audio/bonus_Door_Open.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "background.bonusGameBackground"
                },
                {
                    "name": "bonus_Button",
                    "url": gamePath + `assets/audio/bonus_Button.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.buttonEffect"
                },
                {
                    "name": "reel_Spin",
                    "url": gamePath + `assets/audio/reel_Spin.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.spin"
                },
                {
                    "name": "reel_Spin_FS",
                    "url": gamePath + `assets/audio/reel_Spin_FS.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.spin"
                },
                {
                    "name": "reel_Stop",
                    "url": gamePath + `assets/audio/reel_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.stopReel"
                },
                {
                    "name": "win_Star",
                    "url": gamePath + `assets/audio/win_Star.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds5"
                },
                {
                    "name": "bwin_Text_1",
                    "url": gamePath + `assets/audio/bwin_Text_1.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_Text_2",
                    "url": gamePath + `assets/audio/bwin_Text_2.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_Text_3",
                    "url": gamePath + `assets/audio/bwin_Text_3.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "win_Bed_Start",
                    "url": gamePath + `assets/audio/win_Bed_Start.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "win_Bed_Loop",
                    "url": gamePath + `assets/audio/win_Bed_Loop.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "win_Bed_Stop",
                    "url": gamePath + `assets/audio/win_Bed_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_Bed_MegaWin_Loop",
                    "url": gamePath + `assets/audio/bwin_Bed_MegaWin_Loop.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_Bed_MegaWin_Stop",
                    "url": gamePath + `assets/audio/bwin_Bed_MegaWin_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_Bed_UltraWin_Loop",
                    "url": gamePath + `assets/audio/bwin_Bed_UltraWin_Loop.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_Bed_UltraWin_Stop",
                    "url": gamePath + `assets/audio/bwin_Bed_UltraWin_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "bwin_FreeSpins",
                    "url": gamePath + `assets/audio/bwin_FreeSpins.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.bigWin"
                },
                {
                    "name": "symbol_Star_1",
                    "url": gamePath + `assets/audio/symbol_Star_1.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds4"
                },
                {
                    "name": "symbol_Star_2",
                    "url": gamePath + `assets/audio/symbol_Star_2.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds4"
                },
                {
                    "name": "symbol_Star_3",
                    "url": gamePath + `assets/audio/symbol_Star_3.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds4"
                },
                {
                    "name": "bg_FreeSpins_Start",
                    "url": gamePath + `assets/audio/bg_FreeSpins_Start.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "background.freeSpinsBackground"
                },
                {
                    "name": "bg_FreeSpins_Loop",
                    "url": gamePath + `assets/audio/bg_FreeSpins_Loop.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "background.freeSpinsBackground"
                },
                {
                    "name": "bwin_Coins_Loop",
                    "url": gamePath + `assets/audio/bwin_Coins_Loop.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "level.winAnimBackgroundLevel"
                },
                {
                    "name": "win_Fade_Out",
                    "url": gamePath + `assets/audio/win_Fade_Out.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds2"
                },
                {
                    "name": "bonus_Panel_Appear",
                    "url": gamePath + `assets/audio/bonus_Panel_Appear_Online.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "miscSounds.miscSounds3"
                },
                {
                    "name": "win_Counter_Loop",
                    "url": gamePath + `assets/audio/win_Counter_Loop.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "level.winAnim"
                },
                {
                    "name": "win_Counter_Stop",
                    "url": gamePath + `assets/audio/win_Counter_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "win_FullPlate",
                    "url": gamePath + `assets/audio/win_FullPlate.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winAnim"
                },
                {
                    "name": "ui_Counter",
                    "url": gamePath + `assets/audio/ui_Counter.{ogg,mp3}`,
                    "loop": true,
                    "classVol": "volume.winCounter"
                },
                {
                    "name": "ui_Counter_Stop",
                    "url": gamePath + `assets/audio/ui_Counter_Stop.{ogg,mp3}`,
                    "loop": false,
                    "classVol": "volume.winCounter"
                }
            ],
            "playlists": [

            ]
        },
        "fonts": {
            "fontFamilies": [
                
                {
                    "name": "wintable_font-export",
                    "type": "bitmap"
                },
                {
                    "name": "free_spins_font-export",
                    "type": "bitmap"
                },
                {
                    "name": "font_win-export",
                    "type": "bitmap"
                },
                {
                    "name": "font_info-export",
                    "type": "bitmap"
                },
                {
                    "name": "infoText",
                    "type": "standard"
                }
            ],
            "defaultFamily": "font_win-export",
            "fontSet": [
                {
                    "name": "wintable_font-export",
                    "family": "wintable_font-export",
                    "align": "center",
                    "fontSize": 80,
                    "anchor": [0.5, 0.5],
                    "fontFamily": "wintable_font-export",
                    "isDefault": false
                },
                {
                    "name": "free_spins_font-export",
                    "family": "free_spins_font-export",
                    "align": "center",
                    "fontSize": 80,
                    "anchor": [0.5, 0.5],
                    "isDefault": false
                },
                {
                    "name": "font_info-export",
                    "family": "font_info-export",
                    "align": "center",
                    "fontSize": 80,
                    "anchor": [0.5, 0.5],
                    "isDefault": false
                },
                {
                    "name": "font_win-export",
                    "family": "font_win-export",
                    "align": "center",
                    "fontSize": 80,
                    "anchor": [0.5, 0.5],
                    "isDefault": false
                },
                {
                    "name": "text",
                    "family": "infoText",
                    "align": "left",
                    "fontSize": 20,
                    "anchor": [0.5, 0.5],
                    "isDefault": true,
                    "fill": "0xFFD700",
                    "fontFamily": "Arial",
                    "fontWeight": "bold",
                    "wordWrap": true,
                    "wordWrapWidth": 1040
                }
            ]
        },
        "symbolModel": {
            "enabled": true,
            "animationType": "move",
            "symbolType": "basic",
            "animationDelayStart": 300,
            "animationDelayStop": 300,
            "matrixColumn": 5,
            "matrixRow": 4,
            "symbolSize": {
                "width": 212,
                "height": 140
            },
            "touchZone": {
                "width": 150,
                "height": 150,
                "reels": ["right", "right", "right", "left", "left"],
                "table": "winFactor_background.png",
                "numbers": "winFactor_values.png",
                "font": "wintable_font-export",
                "factors": 3
            },
            "baseMatrix": {
                "x": [205, 423, 640, 857, 1075],
                "y": [140, 140, 140, 140, 140]
            },
            "staticSymbols": {}
        },
        "symbols": [
            {
                "textureName": "symbol_Cherry.png",
                "name": "symbol_Cherry",
                "animations": [],
                "id": 0,
                "textures": {
                    "main": "symbol_Cherry",
                    "blur": "symbol_Cherry_blur"
                },
                "textureSufix": ".png"
            },
            {
                "textureName": "symbol_Lemon.png",
                "name": "symbol_Lemon",
                "animations": [],
                "id": 1,
                "textures": {
                    "main": "symbol_Lemon",
                    "blur": "symbol_Lemon_blur"
                },
                "textureSufix": ".png"
                    },

            {
                "textureName": "symbol_Orange.png",
                "name": "symbol_Orange",
                "animations": [],
                "id": 2,
                "textures": {
                    "main": "symbol_Orange",
                    "blur": "symbol_Orange_blur"
                },
                "textureSufix": ".png"
                    },
            {
                "textureName": "symbol_Plum.png",
                "name": "symbol_Plum",
                "animations": [],
                "id": 3,
                "textures": {
                    "main": "symbol_Plum",
                    "blur": "symbol_Plum_blur"
                },
                "textureSufix": ".png"
                    },
            {
                "textureName": "symbol_Grape.png",
                "name": "symbol_Grape",
                "animations": [],
                "id": 4,
                "textures": {
                    "main": "symbol_Grape",
                    "blur": "symbol_Grape_blur"
                },
                "textureSufix": ".png"
                    },
            {
                "textureName": "symbol_Melon.png",
                "name": "symbol_Melon",
                "animations": [],
                "id": 5,
                "textures": {
                    "main": "symbol_Melon",
                    "blur": "symbol_Melon_blur"
                },
                "textureSufix": ".png"
                    },
            {
                "textureName": "symbol_Bar.png",
                "name": "symbol_Bar",
                "animations": [],
                "id": 6,
                "textures": {
                    "main": "symbol_Bar",
                    "blur": "symbol_Bar_blur"
                },
                "textureSufix": ".png"
                    },
            {
                "textureName": "symbol_Seven.png",
                "name": "symbol_Seven",
                "animations": [],
                "id": 7,
                "textures": {
                    "main": "symbol_Seven",
                    "blur": "symbol_Seven_blur"
                },
                "textureSufix": ".png"
                    },
            {
                "textureName": "symbol_Star.png",
                "name": "symbol_Star",
                "animations": [],
                "id": 8,
                "textures": {
                    "main": "symbol_Star",
                    "blur": "symbol_Star_blur"
                },
                "textureSufix": ".png"
                    },
            {
                "textureName": "symbol_Joker.png",
                "name": "symbol_Joker",
                "animations": [],
                "id": 9,
                "textures": {
                    "main": "symbol_Joker",
                    "blur": "symbol_Joker_blur"
                },
                "textureSufix": ".png"
                    }
        ],
        "flash": {
        },
        "info": {
            "enabled": false,
            "pages": 3
        },
        "c": {
        },
        "s": {
        },
        "h": {
            "sprites": [
                gamePath + `assets/img/bigwin/bigwin.json`,
                gamePath + `assets/img/other.json`,
                gamePath + `assets/img/coins.json`,
                gamePath + `assets/img/freespins/freespins.json`,
                gamePath + `assets/img/info/info.json`,
                gamePath + `assets/img/reels/reels.json`,
                gamePath + `assets/img/reels/lines/lines.json`,
                gamePath + `assets/img/symbols/symbols.json`,
                gamePath + `assets/img/symbols/symbols_blur.json`,
                gamePath + `assets/img/symbols/sticking_wild.json`,

                gamePath + `assets/font/free_spins_font-export.xml`,
                gamePath + `assets/font/font_win-export.xml`,
                gamePath + `assets/font/font_info-export.xml`,
                gamePath + `assets/font/wintable_font-export.xml`,
            ],
            "assets": []
        },
        "lines": [
            {
                "lineNumber": 1,
                "name": "line_04.png",
                "position": {
                    "x": 640,
                    "y": 280
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 2,
                "name": "line_04.png",
                "position": {
                    "x": 640,
                    "y": 420
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 3,
                "name": "line_04.png",
                "position": {
                    "x": 640,
                    "y": 140
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 4,
                "name": "line_04.png",
                "position": {
                    "x": 640,
                    "y": 560
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 5,
                "name": "line_09.png",
                "position": {
                    "x": 640,
                    "y": 275
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 6,
                "name": "line_09.png",
                "position": {
                    "x": 640,
                    "y": 430
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 7,
                "name": "line_03.png",
                "position": {
                    "x": 640,
                    "y": 210
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 8,
                "name": "line_03.png",
                "position": {
                    "x": 640,
                    "y": 495
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 9,
                "name": "line_01.png",
                "position": {
                    "x": 640,
                    "y": 340
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 10,
                "name": "line_01.png",
                "position": {
                    "x": 640,
                    "y": 360
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 11,
                "name": "line_05.png",
                "position": {
                    "x": 640,
                    "y": 360
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 12,
                "name": "line_05.png",
                "position": {
                    "x": 640,
                    "y": 350
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 13,
                "name": "line_05.png",
                "position": {
                    "x": 640,
                    "y": 210
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 14,
                "name": "line_05.png",
                "position": {
                    "x": 640,
                    "y": 490
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 15,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 360
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 16,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 350
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 17,
                "name": "line_06.png",
                "position": {
                    "x": 640,
                    "y": 205
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 18,
                "name": "line_06.png",
                "position": {
                    "x": 640,
                    "y": 500
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 19,
                "name": "line_09.png",
                "position": {
                    "x": 640,
                    "y": 280
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 20,
                "name": "line_09.png",
                "position": {
                    "x": 640,
                    "y": 420
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 21,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 210
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 22,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 490
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 23,
                "name": "line_08.png",
                "position": {
                    "x": 640,
                    "y": 205
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 24,
                "name": "line_08.png",
                "position": {
                    "x": 640,
                    "y": 500
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 25,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 360
                },
                "scale": {
                    "x": -1,
                    "y": 1
                }
            },
            {
                "lineNumber": 26,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 350
                },
                "scale": {
                    "x": -1,
                    "y": -1
                }
            },
            {
                "lineNumber": 27,
                "name": "line_08.png",
                "position": {
                    "x": 640,
                    "y": 220
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 28,
                "name": "line_08.png",
                "position": {
                    "x": 640,
                    "y": 483
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 29,
                "name": "line_03.png",
                "position": {
                    "x": 640,
                    "y": 210
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 30,
                "name": "line_03.png",
                "position": {
                    "x": 640,
                    "y": 490
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 31,
                "name": "line_07.png",
                "position": {
                    "x": 640,
                    "y": 285
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 32,
                "name": "line_07.png",
                "position": {
                    "x": 640,
                    "y": 417
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 33,
                "name": "line_01.png",
                "position": {
                    "x": 640,
                    "y": 345
                },
                "scale": {
                    "x": -1,
                    "y": -1
                }
            },
            {
                "lineNumber": 34,
                "name": "line_01.png",
                "position": {
                    "x": 640,
                    "y": 360
                },
                "scale": {
                    "x": -1,
                    "y": 1
                }
            },
            {
                "lineNumber": 35,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 215
                },
                "scale": {
                    "x": -1,
                    "y": 1
                }
            },
            {
                "lineNumber": 36,
                "name": "line_02.png",
                "position": {
                    "x": 640,
                    "y": 485
                },
                "scale": {
                    "x": -1,
                    "y": -1
                }
            },
            {
                "lineNumber": 37,
                "name": "line_10.png",
                "position": {
                    "x": 640,
                    "y": 275
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
            {
                "lineNumber": 38,
                "name": "line_10.png",
                "position": {
                    "x": 640,
                    "y": 430
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 39,
                "name": "line_11.png",
                "position": {
                    "x": 640,
                    "y": 210
                },
                "scale": {
                    "x": 1,
                    "y": 1
                }
            },
            {
                "lineNumber": 40,
                "name": "line_11.png",
                "position": {
                    "x": 640,
                    "y": 500
                },
                "scale": {
                    "x": 1,
                    "y": -1
                }
            },
        ],
        'grelems': [
        ]
    }
};

export default gameset;